import { Button, Col, Row, Form } from "react-bootstrap";
import EligibilityCheckForm from "./EligibilityCheckForm";
import { useForm } from "react-hook-form";
import FalconComponentCard from "components/common/FalconComponentCard";
import EliglibilityResposne from "./components/EliglibilityResposne";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { SubmitEligibilityCheck } from "./config/eligibilityCheckApi";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import paths from "routes/paths";
import { GetAllPermissionType } from "features/user-permission/config/UserPermissionApi";
import BackButton from "components/common/custom/back-button";
import { handleResetAll } from "features/preauthorization/config/preauthorizationSlice";
import {
  handlePreauthFormData,
  handleResetCreateClaim,
} from "features/cliams/config/claimSlice";
import { handleResetPatientSearch } from "./config/eligibilityCheckSlice";

const EligibilityCheck = () => {
  const dispatch = useDispatch();
  const { allPermissionType } = useSelector((state) => state.role);

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted },
    setValue,
  } = useForm({
    defaultValues: {
      branch: "",
      insurance: "",
      identifier_type: "",
      birth_date: null,
      gender: "",
      marital_status: "",
      profession: "",
      member_id: "",
      network: "",
      policy_no: "",
      patient_mrn: "",
      first_name: "",
      family_name: "",
      policy_holder: "",
      policy_header: "",
      mobile_no: "",
      class_name: "",
      relationship: "",
      religion: "",
      process_priority: "",
      service_period_from_date: "",
      service_period_to_date: "",
      transfer: false,
      emergency: false,
      id: "",
      birth_date: "",
      purpose: [],
      new_born: false,
      is_hijri: false,
      child_mrn: "",
      child_gender: "",
      child_first_name: "",
      child_family_name: "",
      child_birth_name: "",
      child_birth_date: "",
      hijri_date_birth: "",
      id_type: 1,
    },
  });

  const navigate = useNavigate();

  const eligibilitySetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Eligibility",
  );

  const { id } = useParams();

  const handleReset = () => {
    reset();
    setValue("hijri_date_birth", "");
    setValue("id_type", "national");
  };

  useEffect(() => {
    if (!id) {
      dispatch(handleResetAll({ check: "reset" }));
      dispatch(handleResetCreateClaim());
      dispatch(handlePreauthFormData({ check: "reset" }));
      dispatch(handleResetPatientSearch());
    }
  }, [id]);

  const handleEligibilityCheck = async (data) => {
    const rawBody = {
      branch_id:
        watch("branch")?.branch_id ||
        selectedBranch?.branch_id ||
        selectedBranch?.value ||
        "",
      insurance_company_id: watch("insurance")?.insurance_company_id,
      patient_relation: watch("new_born")
        ? "child"
        : watch("relationship")?.patrtl_code,
      eligbchks_startdate: watch("service_period_from_date")
        ? moment(watch("service_period_from_date")).format("YYYY-MM-DD")
        : "",
      eligbchks_enddate: watch("service_period_to_date")
        ? moment(watch("service_period_to_date")).format("YYYY-MM-DD")
        : "",
      patient_memid: watch("member_id"),
      patient_plynum: watch("policy_no"),
      patient_ntwrkno: watch("network"),
      patient_clsnme: watch("class_name"),
      patient_polcyholdr: watch("policy_holder"),
      patient_mrn: watch("patient_mrn"),
      patient_tel: watch("mobile_no"),
      patient_natid: watch("id"),
      patient_finame: watch("first_name"),
      patient_religion: watch("religion")?.religion_code || "",
      patient_faname: watch("family_name"),
      patient_gender: watch("gender")?.genders_code,
      patient_dob: watch("birth_date")
        ? moment(watch("birth_date")).format("YYYY-MM-DD")
        : "",
      patient_marital: watch("marital_status")?.maritalstatus_code,
      patient_profession: watch("profession")?.occup_code,
      idenf_type: watch("identifier_type")?.ident_type_id,
      eligib_purpose: watch("purpose")?.map((item) => item?.value),
      benf_type: watch("process_priority")?.prcspri_code,
      new_born: watch("new_born"),
      patient_benf_mrn: watch("child_mrn"),
      patient_benf_finame: watch("child_first_name"),
      patient_benf_faname: watch("child_family_name"),
      patient_nwbrnrel: watch("new_born") ? "child" : "",
      patient_benf_gender: watch("child_gender")?.value,
      patient_benf_dob: watch("child_birth_date")
        ? moment(watch("child_birth_date")).format("YYYY-MM-DD")
        : "",
      eligb_trans: watch("transfer"),
      eligb_emergency: watch("emergency"),
    };

    // 🔥 Filter out empty or falsy fields
    const body = Object.fromEntries(
      Object.entries(rawBody).filter(
        ([_, value]) =>
          value !== undefined &&
          value !== null &&
          value !== "" &&
          !(Array.isArray(value) && value.length === 0) &&
          value !== false,
      ),
    );

    const id = watch("id");
    const identifierType =
      watch("identifier_type")?.ident_type_code?.toLowerCase();
    const firstChar = id?.charAt(0);

    console.log({ identifierType: watch("identifier_type") });

    if (!id) {
      toast.error("Please enter ID or Iqama No.");
      return;
    }

    if (identifierType == "prc" && firstChar !== "2") {
      toast.error("Iqama No. must start with 2");
      return;
    }

    if (identifierType == "ni" && firstChar !== "1") {
      toast.error("National ID No. must start with 1");
      return;
    }

    if (
      (identifierType == "prc" || identifierType == "ni") &&
      id.length !== 10
    ) {
      toast.error(
        `${identifierType == "prc" ? "Iqama" : "ID"} must be 10 digits`,
      );
      return;
    }

    // if (
    //   identifierType != "prc" &&
    //   identifierType != "ni" &&
    //   ["1", "2"].includes(firstChar)
    // ) {
    //   toast.error(
    //     "ID format does not match: Only National ID or Iqama should start with 1 or 2",
    //   );
    //   return;
    // }

    // return;

    try {
      const response = await dispatch(SubmitEligibilityCheck(body)).unwrap();
      if (response?.success) {
        toast.success(response?.message_en);
        navigate(
          `${paths.eligibilityCheck}?eligibility_id=${response?.data?.eligibility_id}`,
        );
      } else {
        toast.error("Unable to connect to nphies");
      }
    } catch (error) {
      toast.error("Eligibility check failed.");
      console.error("Eligibility Error:", error);
    }
  };

  return (
    <>
      <div className="p-0 d-flex flex-column g-3">
        {Number(eligibilitySetting?.add) === 1 && (
          <Form
            noValidate
            onSubmit={handleSubmit((data) => handleEligibilityCheck(data))}
            className="p-0 d-flex flex-column g-3 mb-3"
          >
            <FalconComponentCard
              className="shadow-md"
              style={{ position: "relative" }}
            >
              <motion.div
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -50, opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <FalconComponentCard.Header
                  className="d-flex fixed-header justify-content-between align-items-center"
                  sx={{
                    position: "sticky !important",
                    top: 52,
                    zIndex: 1020,
                    backgroundColor: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <BackButton
                    path={paths.eligibilityCheckList}
                    title="Eligibility Check"
                  />
                  <Col xs="auto" className="d-flex gap-2">
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button type="submit" size="sm" variant="success">
                      Submit
                    </Button>
                  </Col>
                </FalconComponentCard.Header>
              </motion.div>

              <motion.div
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 50, opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <FalconComponentCard.Body
                  style={{
                    marginTop: "40px",
                    overflowY: "auto",
                    maxHeight: "calc(100vh - 200px)",
                  }}
                >
                  <EligibilityCheckForm
                    setValue={setValue}
                    control={control}
                    onSubmit={handleEligibilityCheck}
                    watch={watch}
                    errors={errors}
                    isSubmitted={isSubmitted}
                    handleReset={handleReset}
                    reset={reset}
                  />
                </FalconComponentCard.Body>
              </motion.div>
            </FalconComponentCard>
          </Form>
        )}

        {Number(eligibilitySetting?.add) !== 1 && !id && (
          <div className="py-6 text-center border rounded-3mb-3">
            <h5 className="text-danger">Permission Denied</h5>
            <p className="text-muted fs-11">
              You do not have permission to submit new eligibility checks.
            </p>
          </div>
        )}

        {Number(eligibilitySetting?.view) === 1 ? (
          <EliglibilityResposne />
        ) : (
          id && (
            <div className="py-6 text-center border rounded-3 bg-white">
              <h5 className="text-danger">Permission Denied</h5>
              <p className="text-muted fs-11">
                You do not have permission to view eligibility details.
              </p>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default EligibilityCheck;
